export default __webpack_public_path__ + "static/media/google.c236e8c1.svg";